export const audioFastForwardIcon = `
<svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 12V0L9 6L0 12ZM10 12V0L19 6L10 12Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
